<h1 class="auth-status-heading">
  {{'auth.invitation.title' | translate}}</h1>
<app-spinner></app-spinner>
